<template>
  <!--begin::Card-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title flex-column" style="justify-content: space-evenly">
        <h3 class="card-label font-weight-bolder text-dark">
          Selected Talents
        </h3>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="tab-content">
            <!--begin::Table-->
            <div v-if="talents && talents.length" class="table-responsive mb-0">
              <table
                class="table table-head-custom table-vertical-center table-head-bg table-borderless"
              >
                <thead>
                  <tr class="text-left">
                    <th>The talent's name</th>
                    <th>Role</th>
                    <th>Qualified</th>
                    <th>Scheduled on</th>
                    <th>Interview Date</th>
                    <th>Clickup Task ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class=""
                    v-for="talent in talents"
                    :key="talent.id"
                    :style="talents.length == 1 ? 'height: 7rem;' : ''"
                  >
                    <td :title="`${talent.talent.full_name}`">
                      <a :href="talent.talent.dashboard_url" target="_blank">{{
                        talent.talent.full_name
                      }}</a>
                    </td>
                    <td>{{ talent.talent.role?.name }}</td>
                    <td>
                      {{ talent.talent.is_qualified ? "Yes" : "No" }}
                    </td>

                    <td>
                      <span class="text-center justify-content-center d-flex">
                        {{
                          talent.created_at
                            ? formatDateTime(talent.created_at)
                            : "-"
                        }}
                      </span>
                    </td>
                    <td>
                      <span class="text-center justify-content-center d-flex">
                        {{
                          talent.interview?.meeting_start_time
                            ? formatInterviewDateTime(
                                talent.interview.meeting_start_time
                              ).datetime
                            : "-"
                        }}
                      </span>
                    </td>

                    <td :style="talents.length == 1 ? 'height: 7rem;' : ''">
                      <div class="d-flex justify-content-center">
                        <div
                          v-if="talent.required_resource?.clickup_task_url"
                          class="d-flex justify-content-center align-items-center"
                        >
                          <a
                            :href="talent?.required_resource?.clickup_task_url"
                            target="_blank"
                            v-b-tooltip.hover="talent?.required_resource?.name"
                          >
                            <img
                              class="d-flex align-items-start"
                              style="height: 2.5rem; width: 2.5rem"
                              src="@/assets/images/clickup.png"
                              alt="clickup"
                            />
                          </a>
                        </div>
                        <div
                          v-if="
                            !talent.required_resource?.clickup_task_url &&
                            checkSelectionTalentsIds(talent.id)
                          "
                        >
                          in progress...
                        </div>
                        <div
                          v-if="
                            !talent.required_resource?.clickup_task_url &&
                            !checkSelectionTalentsIds(talent.id) &&
                            talent.status.id !== 'talent_pending_update' &&
                            talent.status.id !== 'talent_unavailable' &&
                            talent.status.id !== 'client_pending_update' &&
                            talent.status.id !== 'canceled'
                          "
                          class="d-flex justify-content-center align-items-center"
                        >
                          <v-btn
                            class="ma-2 font-weight-bolder"
                            color="success"
                            @click="resyncRequieredResources(talent)"
                          >
                            Auto-Match
                          </v-btn>
                        </div>
                        <div
                          v-if="
                            !talent.required_resource?.clickup_task_url &&
                            !checkSelectionTalentsIds(talent.id) &&
                            (talent.status.id == 'talent_pending_update' ||
                              talent.status.id == 'talent_unavailable' ||
                              talent.status.id == 'client_pending_update' ||
                              talent.status.id == 'canceled')
                          "
                          class="d-flex justify-content-center align-items-center"
                        >
                          -
                        </div>
                        <v-select
                          v-if="false"
                          style="width: 250px"
                          class="mr-2"
                          label="Clickup task ID"
                          :items="requiredResources"
                          item-text="name"
                          item-value="id"
                          deletable-chips
                          dense
                          hide-details
                          outlined
                          v-model="talent.required_resource"
                          @change="statusDropdownChanged(talent)"
                        />
                        <b-button
                          v-if="
                            !checkIdRequiredResourceExists(
                              talent.talent.role?.name
                            ) && false
                          "
                          size="sm"
                          class="mr-5"
                          variant="outline-info"
                          @click="addRequiredResource(talent.id)"
                          ><i class="fas fa-plus px-0 py-0"></i
                        ></b-button>
                      </div>
                      <p v-if="false" class="form__error-label">
                        Please select a clickup task ID
                      </p>
                    </td>

                    <td>
                      <div
                        class="d-flex"
                        :style="
                          talents.length == 1
                            ? 'height: 7rem; align-items: center;'
                            : ''
                        "
                      >
                        <div
                          v-b-tooltip.hover.top="
                            `${
                              interviewStatusesList.find(
                                (i) => i.id == talent.status.id
                              ).name
                            }`
                          "
                        >
                          <v-select
                            style="width: 250px"
                            label="Status"
                            :items="filteredInterviewStatuses(talent)"
                            item-text="name"
                            item-value="id"
                            dense
                            deletable-chips
                            hide-details
                            outlined
                            :disabled="
                              talent.status.id == 'talent_unavailable' ||
                              talent.status.id == 'talent_pending_update' ||
                              talent.status.id == 'client_pending_update' ||
                              talent.status.id == 'talent_pending' ||
                              talent.status.id == 'client_pending' ||
                              talent.status.id == 'canceled' ||
                              talent.status.id == 'talent_reschedule' ||
                              talent.status.id == 'client_reschedule'
                            "
                            v-model="talent.status"
                            :class="getStatusClass(talent.status)"
                            @change="statusDropdownChanged(talent)"
                            return-object

                          />
                        </div>
                        <div
                          class="d-flex justify-content-center ms-3 align-items-center"
                          style="height: 2rem"
                        >
                          <a
                            v-if="
                              talent.status.id == 'canceled'
                            "
                            class="navi-link d-flex justify-content-center mt-3"
                            @click.stop="
                              showRejectionReasonPopup(
                                talent.cancelation_reason,
                                talent?.cancellation_tags,
                                talent?.status_at,
                                talent?.status_by,
                                talent?.cancelled_by,
                                'canceled'
                              )
                            "
                          >
                            <small
                              style="white-space: nowrap; font-weight: bold"
                            >
                              View Cancellation reason
                            </small>
                          </a>
                          <!-- <button
                            v-if="
                              talent.status.id === 'client_reschedule' ||
                              talent.status.id === 'talent_reschedule' ||
                              talent.status.id === 'client_pending'
                            "
                            class="navi-link d-flex justify-content-center mt-3 mx-3"
                            @click.stop="showRescheduleReasonPopup(talent)"
                          >
                            <small
                              style="
                                white-space: nowrap;
                                font-weight: bold;
                                color: #6f56c5;
                              "
                            >
                              View Rescheduling Reason
                            </small>
                          </button> -->
                          <a
                            v-if="
                              talent.status.id == 'rejected' &&
                              talent.rejection_reason
                            "
                            class="navi-link d-flex justify-content-center mt-3"
                            @click.stop="
                              showRejectionReasonPopup(talent.rejection_reason)
                            "
                          >
                            <small
                              style="white-space: nowrap; font-weight: bold"
                            >
                              Rejection Reason
                            </small>
                          </a>
                          <a
                            v-if="
                              ['talent_pending', 'client_pending', 'talent_reschedule', 'client_reschedule'].includes(
                                talent.status.id
                              ) && hideAllActions
                            "
                            class="navi-link d-flex justify-content-center mt-3"
                            @click.stop="showTimesSlotsModal(talent)"
                          >
                            <small
                              style="white-space: nowrap; font-weight: bold"
                            >
                              View proposed slots
                            </small>
                          </a>
                          <a
                            v-if="canCancelInterview(talent?.status?.id)"
                            class="navi-link d-flex justify-content-center mt-3 text-danger mx-2"
                            @click="handleCancelInterview(talent)"
                          >
                            <i
                              class="flaticon2-delete red--text text--darken-3 font-size-h4 cursor-pointer"
                              title="Cancel"
                            ></i>
                          </a>
                        </div>
                        <div
                          class="d-flex justify-content-center ms-3 align-items-center"
                          style="height: 3rem"
                          v-if="
                            talent.feedback_blocked_reason ||
                            talent.acceptance_blocked_reason
                          "
                        >
                          <small
                            style="
                              white-space: nowrap;
                              font-weight: bold;
                              cursor: pointer;
                              color: red;
                            "
                            @click.stop="
                              showFeedbackPopup(
                                talent.feedback_blocked_reason ||
                                  talent.acceptance_blocked_reason
                              )
                            "
                          >
                            Unable to send the email
                          </small>
                        </div>

                        <div
                          v-if="talent.statusChanged && !hideAllActions"
                          class="d-flex justify-content-center"
                        >
                          <button
                            class="btn btn-info btn-sm mr-2"
                            @click="statusChanged(talent)"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn btn-light btn-sm"
                            @click="cancelStatusChange(talent)"
                          >
                            Cancel
                          </button>
                        </div>
                        <div
                          v-if="talent.status.id == 'scheduled'"
                          class="d-flex mx-auto"
                        >
                          <i
                            class="flaticon2-calendar purple--text text--darken-3 font-size-h2 cursor-pointer"
                            title="Reschedule"
                            @click="handleCalendarClick(talent)"
                          ></i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h5
              class="my-5 text-muted text-center d-flex justify-content-center align-items-center"
              style="min-height: 40rem"
              v-else
            >
              No talents Yet
            </h5>
            <div class="pagination-container">
              <p
                v-if="talents && talents.length > 0"
                class="pagination-container__desc"
              >
                {{
                  $t("showing_results", {
                    length: talents.length,
                    total: talentsMeta.total,
                  })
                }}
              </p>
              <b-pagination
                v-if="talentsMeta && talentsMeta.last_page > 1"
                v-model="page"
                :total-rows="talentsMeta.total"
                :per-page="talentsMeta.per_page"
                align="center"
                last-number
                first-number
              ></b-pagination>
            </div>

            <!--end::Table-->
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="showInterviewProposedSlotsModal"
      persistent
      max-width="550px"
      transition="dialog-bottom-transition"
    >
      <v-card v-if="activeTalent && activeTalent.id" class="p-5 p-md-8">
        <ModalHeading :modalTitle="viewProposedSlotsHeader" />
        <div class="dialog-card-content">
          <v-radio-group v-model="selectedInterviewSlot">
            <div
              v-for="group in groupedInterviewSlots"
              :key="group.type.id"
              class="mb-6"
            >
              <v-subheader class="text-h6 font-weight-bold pa-2 mb-2">
                {{ group.type.name }}
              </v-subheader>

              <template
                v-if="
                  [
                    'rescheduled_by_client',
                    'proposed_by_talent',
                    'rescheduled_by_talent',
                  ].includes(group.type.id)
                "
              >
                <!-- Reschedule Reason -->
                <div class="pa-3 mb-2">
                  <div class="d-flex align-items-center mb-2">
                    <v-icon class="mr-2" small>info</v-icon>
                    <span class="font-weight-bold">Reschedule Reason:</span>
                  </div>
                  <p v-if="group.reschedule_reason" class="ml-6 mb-0">
                    {{ group.reschedule_reason }}
                  </p>
                  <p v-else class="ml-6 mb-0 text-muted">No reason provided</p>
                </div>

                <!-- Reschedule Tags -->
                <div class="pa-3 mb-2">
                  <div class="d-flex align-items-center mb-2">
                    <v-icon class="mr-2" small>label</v-icon>
                    <span class="font-weight-bold">Tags:</span>
                  </div>
                  <div
                    v-if="group.tags && group.tags.length > 0"
                    class="ml-6 d-flex flex-wrap"
                  >
                    <v-chip
                      v-for="tag in group.tags"
                      :key="tag.id"
                      small
                      class="ma-1"
                      color="primary"
                    >
                      {{ tag.name }}
                    </v-chip>
                  </div>
                  <p v-else class="ml-6 mb-0 text-muted">No tags</p>
                </div>
              </template>

              <div
                class="d-flex align-center pa-4"
                v-for="slot in group.slots"
                :key="slot.id"
              >
                <v-radio
                  :id="`slot_${slot.id}`"
                  :value="slot.id"
                  :disabled="!slot.is_active"
                  class="pe-2"
                ></v-radio>
                <label
                  :for="`slot_${slot.id}`"
                  :class="{
                    disabled: !slot.is_active,
                  }"
                  :title="`${
                    !slot.is_active ? 'Interview time passed' : 'Interview Slot'
                  }`"
                >
                  <v-card
                    v-if="slot.id !== 'custom'"
                    class="mx-auto cursor-pointer rounded-lg"
                    width="400"
                  >
                    <template v-slot:title>
                      <span class="font-weight-black">{{
                        formatDateTime(slot.start)
                      }}</span>
                    </template>

                    <v-card-text class="bg-surface-light pt-4">
                      <div class="d-flex justify-content-around pa-4">
                        <div class="d-flex flex-column justify-content-center">
                          <b class="text-h5 d-flex justify-content-center">
                            <v-icon class="mr-1">event</v-icon>
                          </b>
                          <span class="d-block mt-2 ms-1">
                            <b>{{ formatInterviewDateTime(slot.start).date }}</b>
                          </span>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <b class="text-h5 d-flex justify-content-center">
                            <v-icon class="mr-1">mdi-clock</v-icon>
                          </b>
                          <span class="d-block mt-2 ms-1">
                            <b>{{ formatInterviewDateTime(slot.start).time }}</b>
                          </span>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <b class="text-h5 d-flex justify-content-center">
                            <v-icon class="mr-1">mdi-account</v-icon>
                          </b>
                          <span class="d-block mt-2 ms-1">
                            <b>{{ slot.owner_type }}</b>
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </label>
              </div>
            </div>
          </v-radio-group>
        </div>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="confirmInterviewSlot(activeTalent)"
            :disabled="!selectedInterviewSlot"
            :class="{ 'cursor-not-allowed': !selectedInterviewSlot }"
          >
            Confirm
          </v-btn>
          <v-btn @click="showInterviewProposedSlotsModal = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rescheduleDialog" max-width="600px">
      <v-card class="pa-3">
        <v-card-title class="headline text-center mb-3"
          >Reschedule Meeting</v-card-title
        >
        <v-card-subtitle
          class="text-h6 text-center purple--text"
          v-if="rescheduleDate"
          >{{ rescheduleDate }}
        </v-card-subtitle>
        <v-card-text>
          <div class="d-flex justify-content-center">
            <DatePicker
              type="datetime"
              v-model="rescheduleDate"
              :show-second="false"
              :disabled-time="disabledTime"
              :disabled-date="disabledDate"
              :min-date="new Date()"
              inline
              :minute-options="getMinuteOptions"
              class="mx-auto"
              v-if="rescheduleDialog"
              @change="validateSelectedTime"
            />
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-content-center pb-4">
          <v-btn color="primary" class="mr-3" @click="handleReschedule()">
            Confirm
          </v-btn>
          <v-btn outlined @click="handleCancelReschedule()"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelModalOpen" max-width="600px">
      <v-card class="pa-3">
        <v-card-title class="headline text-center mb-3">
          Cancel Interview
        </v-card-title>
        <v-card-text>
          <v-form ref="cancelForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="cancelInterviewData.canceled_by"
                    :items="canceledByOptions"
                    label="Canceled by"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="cancelInterviewData.cancellation_tags"
                    :items="cancelationTags"
                    label="Cancellation Tags"
                    ref="cancellationTagsSelect"
                    chips
                    outlined
                    dense
                    deletable-chips
                    item-text="name"
                    item-value="id"
                    small-chips
                    hide-selected
                    hint="Select existing tags"
                    persistent-hint
                    :rules="[
                      (v) =>
                        !!v || 'Please select a cancellation tag to proceed.',
                    ]"
                    @blur="resetScrollPosition"
                  >
                    <template
                      v-slot:selection="{ attrs, item, select, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        small
                        color="primary"
                        @click="select"
                        @click:close="removeTag(item)"
                      >
                        {{ item?.name }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="cancelInterviewData.reason"
                    label="Reason for cancellation"
                    placeholder="Please provide details about why the interview is being canceled..."
                    outlined
                    rows="4"
                    counter
                    maxlength="500"
                    :rules="[
                      (v) => {
                        const selectedTag = this.cancelationTags.find(
                          (tag) =>
                            tag.id ===
                            this.cancelInterviewData.cancellation_tags
                        );
                        const isOtherTag =
                          selectedTag &&
                          selectedTag.name &&
                          selectedTag.name.toLowerCase().includes('other');
                        if (isOtherTag) {
                          return (
                            !!v ||
                            'Please enter a cancellation reason to proceed.'
                          );
                        }
                        return true;
                      },
                      (v) => {
                        const selectedTag = this.cancelationTags.find(
                          (tag) =>
                            tag.id ===
                            this.cancelInterviewData.cancellation_tags
                        );
                        const isOtherTag =
                          selectedTag &&
                          selectedTag.name &&
                          selectedTag.name.toLowerCase().includes('other');
                        if (isOtherTag && v && v.length > 500) {
                          return 'Reason must be less than 500 characters';
                        }
                        return true;
                      },
                    ]"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="cancelModalOpen = false"
            class="mr-2"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#D32F2F"
            @click="confirmCancelInterview"
            class="white--text"
          >
            Confirm Cancellation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showRescheduleReasonDialog"
      max-width="600px"
      persistent
      transition="dialog-top-transition"
    >
      <v-card class="px-5 py-3">
        <ModalHeading modalTitle="Rescheduling Details" />
        <v-card-text class="pt-4">
          <div class="reschedule-reason-content">
            <h6 class="font-weight-bolder text-dark mb-3">
              Rescheduling Reason
            </h6>
            <p v-if="rescheduleReasonData.reason" class="text-break mb-4">
              {{ rescheduleReasonData.reason }}
            </p>
            <p v-else class="text-muted mb-4 h6">
              No rescheduling reason provided.
            </p>

            <div v-if="rescheduleReasonData.tags" class="mt-8">
              <h6 class="font-weight-bolder text-dark mb-3">
                Rescheduling Tags
              </h6>
              <div v-if="rescheduleReasonData.tags.length">
                <v-chip
                  class="mr-2 mb-2"
                  label
                  v-for="(tag, index) in rescheduleReasonData.tags"
                  :key="index"
                  color="primary"
                  outlined
                >
                  {{ typeof tag === "string" ? tag : tag.name || tag.id }}
                </v-chip>
              </div>
              <p v-else class="text-muted mb-0">No tags available.</p>
            </div>
            <!-- horizontal line -->
            <hr class="my-4">
            <div>
              <p class="font-weight-bolder mb-3">
                Action taken by
                {{ rescheduleReasonData.statusBy?.name || "N/A" }} ({{
                  rescheduleReasonData.statusBy?.type || "N/A"
                }}) on
                {{
                  rescheduleReasonData.statusAt
                    ? formatDateTime(rescheduleReasonData.statusAt)
                    : "N/A"
                }}
              </p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-content-end p-2">
          <v-btn
            color="#3699FF"
            @click="closeRescheduleReasonDialog"
            style="color: white"
            class="hover-primary"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import ModalHeading from "@/components/UI/ModalHeading.vue";
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    ModalHeading,
    DatePicker,
  },
  props: {
    selectedProject: {
      type: Number,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 8,
      hideAllActions: true,
      showError: false,
      activeTalent: null,
      selectedInterviewSlot: null,
      showInterviewProposedSlotsModal: false,
      talentToShowError: null,
      query: {},
      talentsPreviousValue: null,
      rescheduleDate: null,
      rescheduleDialog: false,
      selectedTalent: null,
      showRescheduleReasonDialog: false,
      rescheduleReasonData: {
        reason: null,
        talent: null,
        tags: null,
      },
      cancelModalOpen: false,
      selectedCancelTalent: null,
      cancelInterviewData: {
        reason: "",
        canceled_by: 2,
        cancellation_tags: null,
      },
      canceledByOptions: [
        { text: "Client", value: 2 },
        { text: "Talent", value: 1 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      talents: "clients/getSelectedTalentsList",
      talentsMeta: "clients/getSelectedTalentsMeta",
      interviewStatuses: "clients/getTalentInterviewStatus",
      requiredResources: "clients/getProjectRequiredResources",
      clientCancellationTags: "clients/getClientCancellationTags",
      talentCancellationTags: "clients/getTalentCancellationTags",
    }),
    interviewStatusesList() {
      return this.interviewStatuses.map((status) => {
        if (status.id === "talent_pending_update") {
          return {
            ...status,
            name: "Pending talent confirmation",
          };
        } else if (status.id === "client_pending_update") {
          return {
            ...status,
            name: "Pending client time slots",
          };
        } else if (status.id === "talent_pending") {
          return {
            ...status,
            name: "Pending talent meeting confirmation",
          };
        } else if (status.id === "client_pending") {
          return {
            ...status,
            name: "Pending client confirmation on new slots",
          };
        }
        return status;
      });
    },
    projectId() {
      return this.$route.params.project_id;
    },
    talentsQuery() {
      return {
        page: this.page,
        perPage: this.perPage,
        ...this.query,
      };
    },
    disabledTime() {
      return (date) => {
        const hours = date.getHours();

        return hours < 9 || hours > 17;
      };
    },
    disabledDate() {
      return (date) => {
        const day = date.getDay();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        const pastDays = checkDate < today;
        return day === 5 || day === 6 || pastDays;
      };
    },
    getMinuteOptions() {
      if (this.rescheduleDate && this.rescheduleDate.getHours() === 17) {
        return [0];
      } else {
        return [0, 30];
      }
    },
    viewProposedSlotsHeader() {
      if (this.activeTalent.status.id === "talent_reschedule") {
        return "Proposed by Talent";
      } else if (this.activeTalent.status.id === "client_reschedule") {
        return "Proposed by Client";
      } else {
        return "View proposed slots";
      }
    },
    groupedInterviewSlots() {
      if (!this.activeTalent || !this.activeTalent.interview_slots) {
        return [];
      }

      const grouped = {};
      this.activeTalent.interview_slots.forEach((slot) => {
        const typeId = slot.type?.id || "unknown";
        if (!grouped[typeId]) {
          grouped[typeId] = {
            type: slot.type,
            slots: [],
            reschedule_reasons: [],
            reschedule_tags: [],
          };
        }
        grouped[typeId].slots.push(slot);

        if (
          slot.reschedule_reason &&
          !grouped[typeId].reschedule_reasons.includes(slot.reschedule_reason)
        ) {
          grouped[typeId].reschedule_reasons.push(slot.reschedule_reason);
        }

        if (slot.reschedule_tags && Array.isArray(slot.reschedule_tags)) {
          slot.reschedule_tags.forEach((tag) => {
            if (
              tag &&
              !grouped[typeId].reschedule_tags.some(
                (existingTag) => existingTag.id === tag.id
              )
            ) {
              grouped[typeId].reschedule_tags.push(tag);
            }
          });
        }
      });

      return Object.values(grouped).map((group) => ({
        ...group,
        slots: group.slots,
        reschedule_reason:
          group.reschedule_reasons.length > 0
            ? group.reschedule_reasons[0]
            : null,
        tags: group.reschedule_tags,
      }));
    },
    isFormValid() {
      const selectedTag = this.cancelationTags.find(
        (tag) => tag.id === this.cancelInterviewData.cancellation_tags
      );
      const isOtherTag =
        selectedTag &&
        selectedTag.name &&
        selectedTag.name.toLowerCase().includes("other");

      return (
        this.cancelInterviewData.canceled_by &&
        this.cancelInterviewData.cancellation_tags &&
        (!isOtherTag ||
          (this.cancelInterviewData.reason &&
            this.cancelInterviewData.reason.length <= 500))
      );
    },
    cancelationTags() {
      if (this.cancelInterviewData.canceled_by === 2) {
        return this.clientCancellationTags;
      } else {
        return this.talentCancellationTags;
      }
    },
  },
  watch: {
    async selectedProject() {
      this.page = 1;
      const payload = {
        project_id: this.selectedProject,
        talentsQuery: this.talentsQuery,
      };
      await this.getSelectedTalentsList(payload).then(() => {
        this.talentsPreviousValue = this.talents.map((talent) => ({
          ...talent,
        }));
      });
      // await this.getProjectRequiredResources(payload);
    },
    async page() {
      const payload = {
        project_id: this.projectId,
        talentsQuery: this.talentsQuery,
      };
      await this.getSelectedTalentsList(payload).then(() => {
        this.talentsPreviousValue = this.talents.map((talent) => ({
          ...talent,
        }));
      });
    },
    "cancelInterviewData.canceled_by"() {
      this.cancelInterviewData.cancellation_tags = null;
    },
    cancelModalOpen(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.onModalClose();
      }
    },
    "cancelInterviewData.cancellation_tags" () {
      if (this.$refs.cancelForm) {
        this.$refs.cancelForm.resetValidation();
      }
    }
  },
  async mounted() {
    this.getSelectedTalents();
    this.getTalentStatuses();
  },
  methods: {
    ...mapActions({
      getSelectedTalentsList: "clients/getSelectedTalentsList",
      setSelectedInterviewSlot: "clients/setSelectedInterviewSlot",
      getProjectRequiredResources: "clients/getProjectRequiredResources",
      getTalentStatuses: "clients/getTalentStatuses",
      createRequiredResource: "clients/createRequiredResource",
      resyncMatchTalentWithRequieredResources:
        "clients/resyncMatchTalentWithRequieredResources",
      rescheduleInterviewDate: "clients/rescheduleInterview",
      getSelectionTags: "clients/getCancellationTags",
      cancelInterview: "clients/cancelInterview",
    }),
    itsBeforeNow(date) {
      return dayjs(date).isBefore(dayjs());
    },
    async confirmInterviewSlot(talent) {
      const selectedSlot = this.selectedInterviewSlot;
      console.log(talent);
      const payload = {
        selection_id: talent.id,
        interview_slot_id: selectedSlot !== "custom" ? selectedSlot : null,
      };

      await this.setSelectedInterviewSlot(payload).then(() => {
        this.showInterviewProposedSlotsModal = false;
        this.getSelectedTalents();
      });
    },
    async getSelectedTalents() {
      const payload = {
        project_id: this.projectId,
        talentsQuery: this.talentsQuery,
      };
      await this.getSelectedTalentsList(payload).then(() => {
        this.talentsPreviousValue = this.talents.map((talent) => ({
          ...talent,
        }));
      });

      let selectionPanddingTalentsIds =
        JSON.parse(localStorage.getItem("selectionTalentsIds")) || [];

      this.talents.map((talent) => {
        if (
          talent.required_resource &&
          selectionPanddingTalentsIds.includes(talent.id)
        ) {
          selectionPanddingTalentsIds = selectionPanddingTalentsIds.filter(
            (id) => id !== talent.id
          );
        }
      });

      if (selectionPanddingTalentsIds.length > 0) {
        setTimeout(() => {
          this.getSelectedTalents();
        }, 5000);
      }

      localStorage.setItem(
        "selectionTalentsIds",
        JSON.stringify(selectionPanddingTalentsIds)
      );
    },
    checkSelectionTalentsIds(talentId) {
      let selectionTalentsIds =
        JSON.parse(localStorage.getItem("selectionTalentsIds")) || [];
      return selectionTalentsIds.includes(talentId);
    },
    showTimesSlotsModal(selectedTalent) {
      this.activeTalent = null;
      this.activeTalent = this.talents.find(
        (talent) => talent.id === selectedTalent.id
      );
      if (!this.activeTalent.id) return;

      if (this.activeTalent.status.id == "talent_pending")
        this.selectedInterviewSlot = this.activeTalent.interview_slots[0].id;
      else if (this.activeTalent.status.id == "talent_unavailable")
        this.selectedInterviewSlot = "custom";

      this.showInterviewProposedSlotsModal = true;
    },
    showRejectionReasonPopup(
      reason,
      tags = null,
      status_at = null,
      status_by = null,
      cancelled_by = null,
      status = null
    ) {
      const h = this.$createElement;

      const elements = [];

      if (status === "canceled") {
        elements.push(
          h("div", { class: "mb-3" }, [
            h(
              "div",
              {
                class: "font-weight-bold mb-2",
                style: { fontSize: "14px", color: "#333" },
              },
              "Type"
            ),
            h(
              "div",
              {
                class: "",
                style: { fontSize: "14px", color: "#747a87" },
              },
              "Cancelled by " + (cancelled_by?.name ?? "Product")
            ),
          ])
        );
      }

      elements.push(
        h("div", { class: "mb-3" }, [
          h(
            "div",
            {
              class: "font-weight-bold mb-2",
              style: { fontSize: "14px", color: "#333" },
            },
            "Reason"
          ),
          h(
            "div",
            {
              class: "p-3",
              style: {
                backgroundColor: "#dee1e6",
                color: "#757c89",
                borderRadius: "4px",
                fontSize: "12px",
                lineHeight: "1.5",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: "200px",
                overflowY: "auto",

              },
            },
            reason || "N/A"
          ),
        ])
      );

      if (tags && Array.isArray(tags) && tags.length > 0) {
        elements.push(
          h("div", { class: "mb-3" }, [
            h(
              "div",
              {
                class: "font-weight-bold mb-2",
                style: { fontSize: "14px", color: "#333" },
              },
              "Tags"
            ),
            h(
              "div",
              {
                class: "d-flex flex-wrap",
              },
              tags.map((tag) =>
                h(
                  "span",
                  {
                    class: "badge mr-2 mb-1 px-2 py-1",
                    style: {
                      backgroundColor: "#e9ecef",
                      color: "#495057",
                      fontSize: "12px",
                      fontWeight: "normal",
                      borderRadius: "4px",
                    },
                  },
                  tag?.name || tag
                )
              )
            ),
          ])
        );
      }

      if (status_by && status_at) {
        const actionText = `Action taken by ${status_by?.type}: ${
          status_by?.name
        } on ${new Date(status_at).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })} ${new Date(status_at).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })} UTC`;

        elements.push(
          h(
            "div",
            {
              class: "mt-3",
              style: {
                fontSize: "12px",
                borderTop: "1px solid #e9ecef",
                paddingTop: "12px",
              },
            },
            actionText
          )
        );
  }

      this.$bvModal.msgBoxOk(elements, {
        title:
          status === "canceled" ? "Cancellation reason" : "Rejection Reason",
        size: "md",
        buttonSize: "md",
        okVariant: "primary",
        okTitle: "OK",
        headerClass: "px-4 py-3 border-bottom",
        footerClass: "px-4 py-3 border-top-0 d-flex justify-content-end",
        bodyClass: "px-4 py-3",
        centered: true,
        hideHeaderClose: false,
        headerTextVariant: "dark",
        bodyTextVariant: "dark",
        modalClass: "rejection-reason-modal",
  });
},
    showFeedbackPopup(reason) {
      this.$bvModal.msgBoxOk(
        reason.replace("Required resource is missing fields: ", ""),
        {
          title: "Required Resource Missing Fields",
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          headerClass: "p-4 border-bottom-1",
          footerClass: "p-2 border-top-0",
          bodyClass: "text-break",
          centered: true,
        }
      );
    },
    showRescheduleReasonPopup(talent) {
      this.rescheduleReasonData = {
        reason: talent.reschedule_reason || null,
        talent: talent,
        tags: talent?.reschedule_tags,
        statusAt: talent?.status_at || "N/A",
        statusBy: talent?.status_by || "N/A",
      };
      this.showRescheduleReasonDialog = true;
    },
    closeRescheduleReasonDialog() {
      this.showRescheduleReasonDialog = false;
      this.rescheduleReasonData = {
        reason: null,
        talent: null,
        tags: null,
        statusAt: null,
        statusBy: null,
      };
    },
    resyncRequieredResources(talent) {
      this.resyncMatchTalentWithRequieredResources({
        project_id: this.projectId,
        selection: talent.id,
        talentsQuery: this.talentsQuery,
      }).then(() => {
        let selectionTalentsIds =
          JSON.parse(localStorage.getItem("selectionTalentsIds")) || [];
        if (!selectionTalentsIds.includes(talent.id)) {
          selectionTalentsIds.push(talent.id);
          localStorage.setItem(
            "selectionTalentsIds",
            JSON.stringify(selectionTalentsIds)
          );
        }

        if (selectionTalentsIds.length > 0) {
          this.getSelectedTalents();
        }
      });
    },
    getStatusClass(status) {
      const statusClasses = {
        scheduled: "darkblue-status-selected-talent",
        accepted: "darkgreen-status-selected-talent",
        rejected: "darkturquoise-status-selected-talent",
        talent_no_show: "darkred-status-selected-talent",
        client_no_show: "darkred-status-selected-talent",
        completed: "darkorange-status-selected-talent",
        canceled: "darkred-status-selected-talent",
        expired: "crimson-status-selected-talent",
        hired: "tealblue-status-selected-talent",
      };
      return statusClasses[status.id ? status.id : status] || "";
    },
    checkIdRequiredResourceExists(roleName) {
      return this.requiredResources.some(
        (resource) => resource.name?.split(" | ")[1] === roleName
      );
    },
    formatDateTime(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },

    formatInterviewDateTime(date) {
      const formattedDate = dayjs(date).format("DD/MM/YYYY");
      const formattedTime = dayjs(date).format("hh:mm A");
      const datetime = `${formattedDate} at ${formattedTime}`;
      return { date: formattedDate, time: formattedTime, datetime };
    },
    statusDropdownChanged(talent) {
      if (talent.talent) {
        talent.statusChanged = true;
        this.hideAllActions = false;
      } else {
        this.showError = true;
        this.talentToShowError = talent;
      }
    },
    cancelStatusChange(talent) {
      const talentPrevious = this.talentsPreviousValue.find(
        (t) => t.id === talent.id
      );
      const currentTalent = this.talents.find((t) => t.id === talent.id);

      currentTalent.status = talentPrevious.status;

      talent.statusChanged = false;
      this.hideAllActions = true;
    },
    async statusChanged(talent) {
      const { id, status } = talent;
      await this.$store
        .dispatch("clients/updateTalentStatus", {
          selection: id,
          status: status.id ? status.id : status,
          project_id: this.projectId,
          talentsQuery: this.talentsQuery,
        })
        .then(() => {
          this.getSelectedTalents();
        });

      talent.statusChanged = false;
      this.showError = false;
      this.talentToShowError = null;
    },
    addRequiredResource(talentId) {
      this.createRequiredResource({
        project_id: this.projectId,
        selection: talentId,
        talentsQuery: this.talentsQuery,
      });
    },
    handleCancelReschedule() {
      this.rescheduleDialog = false;
      this.rescheduleDate = null;
      this.selectedTalent = null;
    },

    async handleReschedule() {
      if (!this.rescheduleDate) {
        this.rescheduleDialog = false;
        this.selectedTalent = null;
        this.$toasted.show("No action has been taken", {
          type: "warning",
          icon: "warning",
        });
        return;
      }

      const year = this.rescheduleDate.getUTCFullYear();
      const month = String(this.rescheduleDate.getUTCMonth() + 1).padStart(
        2,
        "0"
      );
      const day = String(this.rescheduleDate.getUTCDate()).padStart(2, "0");
      const hours = String(this.rescheduleDate.getUTCHours()).padStart(2, "0");
      const minutes = String(this.rescheduleDate.getUTCMinutes()).padStart(
        2,
        "0"
      );
      const data = {
        slot: `${year}-${month}-${day} ${hours}:${minutes}`,
      };
      try {
        this.rescheduleDialog = false;
        await this.rescheduleInterviewDate({
          selection_id: this.selectedTalent.id,
          data,
        });
        this.rescheduleDate = null;
        this.selectedTalent = null;
        this.$toasted.show("Talent rescheduled successfully", {
          type: "success",
          icon: "check_circle",
        });
        this.getSelectedTalents();
        this.getTalentStatuses();
      } catch (error) {
        console.log(error);
        this.rescheduleDialog = false;
        this.rescheduleDate = null;
        this.selectedTalent = null;
        this.$toasted.show("Error rescheduling talent", {
          type: "error",
          icon: "error",
        });
      }
    },
    validateSelectedTime(date) {
      if (!date) return;

      const now = new Date();
      const selectedDate = new Date(date);

      const isToday =
        selectedDate.getDate() === now.getDate() &&
        selectedDate.getMonth() === now.getMonth() &&
        selectedDate.getFullYear() === now.getFullYear();

      if (isToday) {
        const currentHour = now.getHours();
        const selectedHour = selectedDate.getHours();
        const currentMinute = now.getMinutes();
        const selectedMinute = selectedDate.getMinutes();

        if (
          selectedHour < currentHour ||
          (selectedHour === currentHour && selectedMinute <= currentMinute)
        ) {
          this.rescheduleDate = null;
          this.$toasted.show("Please select a future slot", {
            type: "error",
            icon: "error",
          });
        }
      } else {
        this.rescheduleDate = date;
      }
    },
    handleCalendarClick(talent) {
      this.selectedTalent = talent;
      this.rescheduleDialog = true;
    },
    async handleCancelInterview(talent) {
      this.selectedCancelTalent = talent;
      try {
        await Promise.all([
          this.getSelectionTags({
            type: 2,
            selection_id: this.selectedCancelTalent.id,
          }), // 2 for client tags
          this.getSelectionTags({
            type: 1,
            selection_id: this.selectedCancelTalent.id,
          }), // 1 for talent tags
        ]);
      } catch (error) {
        console.error("Error fetching cancellation tags:", error);
      }
      this.cancelModalOpen = true;
    },
    removeTag() {
      this.cancelInterviewData.cancellation_tags = null
    },
    confirmCancelInterview() {
       if (this.$refs.cancelForm) {
        this.$refs.cancelForm.validate();
      }
      if (this.isFormValid) {
        const payload = {
          selectionId: this.selectedCancelTalent.id,
          cancelation_reason: this.cancelInterviewData.reason,
          cancelled_by: this.cancelInterviewData.canceled_by,
          cancellation_tags: [this.cancelInterviewData.cancellation_tags],
        };

        this.$store
          .dispatch("clients/cancelInterview", payload)
          .then(() => {
            this.$toasted.show("Interview canceled successfully", {
              type: "success",
              icon: "check_circle",
            });
            this.getSelectedTalents();
            this.getTalentStatuses();
          })
          .catch((error) => {
            console.error("Error canceling interview:", error);
            this.$toasted.show(
              error.response?.data?.message ||
                "Error canceling the interview. Please try again.",
              {
                type: "error",
                icon: "error",
              }
            );
          });
        this.cancelModalOpen = false;
      }
    },
    onModalClose() {
      this.cancelInterviewData = {
        reason: "",
        canceled_by: 2,
        cancellation_tags: null,
      };
      this.selectedCancelTalent = null;
      if (this.$refs.cancelForm) {
        this.$refs.cancelForm.resetValidation();
      }
    },
    canCancelInterview(status) {
      const canCancelOptions = [
        "scheduled",
        "client_pending",
        "client_pending_update",
        "talent_pending",
        "talent_pending_update",
        "talent_reschedule",
        "client_reschedule",
      ];
      return canCancelOptions.includes(status)
    },
    resetScrollPosition() {
      this.$nextTick(() => {
        const selectors = [
          ".v-menu__content",
          ".v-select-list",
          ".v-menu__content .v-list",
      ];

        for (const selector of selectors) {
          const elements = document.querySelectorAll(selector);
          for (const element of elements) {
            if (element.scrollTop > 0) {
              element.scrollTop = 0;
            }
          }
      }
      });
    },
    filteredInterviewStatuses(talent) {
    const statuses = this.interviewStatusesList.filter(
        (status) => status.id !== "canceled"
      );

    if (talent?.status?.id === "canceled") {
        statuses.push(talent.status);
    }

    return statuses;
    }
  },
};
</script>

<style>
.darkblue-status-selected-talent .v-select__selections {
  color: darkblue !important;
}

.darkgreen-status-selected-talent .v-select__selections {
  color: darkgreen !important;
}

.darkturquoise-status-selected-talent .v-select__selections {
  color: #71ec71 !important;
}

.darkred-status-selected-talent .v-select__selections {
  color: darkred !important;
}

.darkorange-status-selected-talent .v-select__selections {
  color: darkorange !important;
}

.darkturquoise-status-selected-talent .v-select__selections {
  color: #71ec71 !important;
}

.crimson-status-selected-talent .v-select__selections {
  color: crimson !important;
}

.tealblue-status-selected-talent .v-select__selections {
  color: #006400 !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.mx-time-list .mx-time-item.disabled {
  display: none;
}
.mx-calendar {
  width: 100% !important;
}
</style>
